import Layout from "../../hoc/getStartedLayout";
import ForgotPasswordContent from "../../components/getStarted/forgotPassword";
import { withRouter } from 'next/router';
import dynamic from 'next/dynamic';

function ForgotPassword(props) {
	const meta = {
		title: "Find Your Bayan Account",
		description: "Enter your email associated with your Bayan Account to receive a one-time temporary link to log into Bayan.",
		route: "forgot-password",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<ForgotPasswordContent router={props.router} />
			</Layout>
		</>
	);
}

export default withRouter(ForgotPassword);
